import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const GetMemoByObjectGuid = guid => get(url.GET_MEMO, { params: { guid } })